
import React from "react";
import { 
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";

interface SentimentErrorDialogProps {
  isOpen: boolean;
  onClose: () => void;
  errorMessage: string;
}

export const SentimentErrorDialog: React.FC<SentimentErrorDialogProps> = ({
  isOpen,
  onClose,
  errorMessage
}) => {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent className="bg-secondary border border-primary">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">AI Analysis Error</AlertDialogTitle>
          <AlertDialogDescription className="text-gray-300">
            {errorMessage} The analysis will continue with sample data that may not accurately reflect current sentiment.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onClose} className="bg-primary text-black hover:bg-primary/80">
            Understood
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
